import { gql } from "apollo-boost"

export const CREATE_ROLE_PERMISSION = gql`
mutation CreateRolePermission($data: RoleInput) {
    createRolePermission(data: $data) {
      message
    }
  }
`;

export const UPDATE_ROLE_PERMISSION = gql`
mutation UpdateRolePermission($data: RoleInput!, $where: RoleWhereInput!) {
  updateRolePermission(data: $data, where: $where) {
    message
  }
}
`;

export const DELETED_ROLE_PERMISSION = gql`
mutation DeleteRolePermission($where: RoleWhereInput!) {
    deleteRolePermission(where: $where) {
      message
    }
  }
`;


